// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Appends the next page of products instead of jumping to it. The button stays a
// real link, so a failed request or a disabled script still leads to page two.
(() => {
  // Liefert die eigentliche Produktliste, auch wenn der Selektor auf einen Wrapper zeigt.
  const resolveList = (root) => {
    if (!root) return null;
    if (root.matches('ul, ol')) return root;
    return root.querySelector('ul.product-grid, ul.grid') || null;
  };

  const init = (box) => {
    if (box.dataset.spReady) return;
    box.dataset.spReady = 'on';

    const button = box.querySelector('[data-sp-load-more-button]');
    if (!button) return;

    button.addEventListener('click', async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
      event.preventDefault();
      if (box.dataset.spBusy) return;

      const url = button.href;
      // Auf der Suchseite traegt nicht die Liste die id "product-grid", sondern ein
      // Wrapper, der den Ladeblock mit umschliesst. Wuerde hier der Wrapper befuellt,
      // landeten neue Produkte hinter dem Zaehler - samt zweiter, nicht verdrahteter
      // Schaltflaeche, die beim Klick die Seite neu laedt.
      const target = resolveList(document.querySelector(box.dataset.target));
      if (!target) { window.location.href = url; return; }

      box.dataset.spBusy = 'on';
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url, { headers: { 'X-Requested-With': 'sp-load-more' } });
        if (!response.ok) throw new Error(String(response.status));
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        const incoming = resolveList(doc.querySelector(box.dataset.target));
        const items = incoming ? [...incoming.children] : [];
        target.append(...items);

        // Shopifys Suche meldet deutlich mehr Treffer, als sie ausliefert: bei
        // "lacoste" 1000, geliefert werden 42, ab Seite 4 kommt eine leere Seite.
        // Deshalb zaehlen wir, was wirklich im Raster steht, und beenden die Liste,
        // sobald eine Seite nichts mehr bringt - statt dorthin zu navigieren.
        const nextBox = doc.querySelector('[data-sp-load-more]');
        const nextButton = nextBox && nextBox.querySelector('[data-sp-load-more-button]');
        const fertig = !items.length || !nextButton;

        const shown = target.children.length;
        let total = Number(box.dataset.total) || shown;
        if (fertig || shown > total) total = shown;
        box.dataset.shown = String(shown);
        box.dataset.total = String(total);

        // Solange die Gesamtzahl unzuverlaessig ist, nur die geladene Menge zeigen.
        const unsicher = box.dataset.totalUnreliable === 'on' && !fertig;
        const count = box.querySelector('.sp-load-more__count');
        const vorlage = unsicher ? box.dataset.countSimple : box.dataset.countTemplate;
        if (count && vorlage) {
          count.textContent = vorlage.replace('@shown@', shown).replace('@total@', total);
        }
        const bar = box.querySelector('.sp-load-more__track > span');
        const fortschritt = unsicher ? 0 : (total > 0 ? Math.round((shown / total) * 100) : 100);
        if (bar) bar.style.setProperty('--sp-progress', `${fortschritt}%`);

        if (fertig) {
          button.remove();
        } else {
          button.href = nextButton.href;
        }

        // Let the wishlist and quick-add layers pick up the new cards.
        document.dispatchEvent(new CustomEvent('sp:products-appended', { detail: { url } }));
        boot();
        window.dispatchEvent(new Event('resize'));
      } catch (error) {
        window.location.href = url;
      } finally {
        box.dataset.spBusy = '';
        button.removeAttribute('aria-busy');
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-sp-load-more]').forEach(init);
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
